import { getParamString, removeEmptyValues } from '@/utils/tools';
import { sign } from './utils';

const secretKey = '3VIDRSDxD0Ck2b6e9K0RaB9Xo5s81tep';

export function gopController(config) {
  // 请求配置
  const { api, data, query, type, headers } = config;
  if (window.localStorage.getItem('log')) {
    // console.log(
    //   api,
    //   config,
    // );
  }
  // 固定参数
  const signQuery = {
    app_key: headers?.appKey,
    sign_method: 'sha256',
    timestamp: new Date().getTime(),
    format: 'json',
    simplify: true,
  };

  // 请求头部
  const initHeaders = {
    uaCipher: '',
    accessToken: null,
    'Content-Type': 'application/x-www-form-urlencoded',
    ...config.headers,
  };

  // 将参数加密，加密后的参数和加签参数都要放到 query 上
  const signParams = { ...signQuery, ...data, ...query, method: api };

  // 拼接成字符串
  // 过滤空值
  const paramStr = getParamString('', signParams);

  // 加密
  const signStr = sign(paramStr, secretKey);

  // 真正传的时候不能传空值成员
  let filterData = removeEmptyValues(data);
  return {
    api: '',
    params: {
      method: api, // 请求的api
      ...signQuery, // 公共参数
      ...query, // get参数
      sign: signStr, // 加密后的密钥
    },
    data: filterData,
    headers: initHeaders,
    type,
  };
}

export function httpController(config) {
  const { api, data, type } = config;
  const defaultInfo = {
    base_url: 'https://daily-larkportal-oversea.taobao.net/gateway/hsf/gop/execute/',
    access_token: 'EB64BA13CF72F25E688F34E312F50D0BEB64BA13CF72F25E688F34E312F50D0B',
  };
  const result = {
    api: `${defaultInfo.base_url}?api=${api}&access_token=${defaultInfo.access_token}`,
    data: {
      data: JSON.stringify(data),
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    params: null,
    type: type || 'POST',
  };
  console.log('log_[result]==>', result);
  return result;
}
